import React from "react";
import "./modal.css";
import { ClipLoader } from "react-spinners";

const Modal = ({
  children,
  heading,
  paragraph,
  closeModal,
  btnFuntion,
  isLoading,
  btnText,
}) => {
  return (
    <div onClick={closeModal} className="modal-overlay">
      <div
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="modal-content animate__animated animate__zoomIn animate__faster"
      >
        <h1 className="modal-h">{heading}</h1>
        <p className="modal-p">{paragraph}</p>

        {children}

        <div className="modal-btns-div">
          <div className="modal-secondary-btn" onClick={closeModal}>
            Close
          </div>
          <div className="modal-primary-btn" onClick={btnFuntion}>
            {isLoading ? <ClipLoader size={20} color={"#fff"} /> : btnText}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
